module.exports = __webpack_public_path__ + "static/media/product2.16452b79.jpg";